export default __webpack_public_path__ + "static/media/extraction.44f819bc.svg";